import {
  DELETE_SUBRECORD,
  IDeleteSubrecordAction,
  SET_SUBRECORDS,
  ISetSubrecordAction,
  ADD_SUBRECORD,
  IAddSubrecordAction,
  SET_SUBRECORD_CONFIRMED_BY_BACKEND,
  ISetSubrecordConfirmedByBackendAction,
  ISubrecordConfirmationData,
  CLEAR_SUBRECORDS,
  INewSubrecord,
  ISubrecord,
  ICreateSubrecordParams,
  IClearSubrecordAction,
} from './types';
import { WsCommandSubject } from '../crud/types';
import { prepareCreateCommandAction, prepareReadCommandAction, prepareDeleteCommandAction } from '../crud/actions';

// CRUD operations
export const prepareCreateSubrecordCommandAction = (subrecord: INewSubrecord) =>
  prepareCreateCommandAction({
    type: 'subrecords' as WsCommandSubject,
    params: subrecord as ICreateSubrecordParams,
  });

export const prepareReadSubrecordsCommandAction = (record_id: string) =>
  prepareReadCommandAction({
    type: 'subrecords' as WsCommandSubject,
    params: { record_id },
  });

export const prepareDeleteSubrecordCommandAction = (params: { record_id: string; subrecord_id: string; replaceChatWithConsolidation?: boolean }) =>
  prepareDeleteCommandAction({
    type: 'subrecords' as WsCommandSubject,
    params,
  });

// Regular actions
export const setSubrecordAction = (recordId: string, subrecords: ISubrecord[]): ISetSubrecordAction => ({
  type: SET_SUBRECORDS,
  payload: { recordId, subrecords },
});

export const addSubrecordAction = (subrecord: ISubrecord): IAddSubrecordAction => ({
  type: ADD_SUBRECORD,
  payload: subrecord,
});

export const deleteSubrecordAction = (recordId: string, subrecordId: string): IDeleteSubrecordAction => ({
  type: DELETE_SUBRECORD,
  payload: { recordId, subrecordId },
});

export const setSubrecordConfirmedByBackendAction = (
  recordId: string,
  subrecordId: string,
  data: ISubrecordConfirmationData,
): ISetSubrecordConfirmedByBackendAction => ({
  type: SET_SUBRECORD_CONFIRMED_BY_BACKEND,
  recordId,
  subrecordId,
  data,
});

export const clearSubrecordAction = (): IClearSubrecordAction => ({
  type: CLEAR_SUBRECORDS,
});
